const CONSENT_KEY = 'myservices-consent-v1'
const CONSENT_EVENT = 'myservices-consent-changed'

export const defaultConsent = Object.freeze({
  necessary: true,
  preferences: false,
  decided: false
})

export const getConsent = () => {
  try {
    const storedConsent = JSON.parse(localStorage.getItem(CONSENT_KEY))

    return {
      necessary: true,
      preferences: storedConsent?.preferences === true,
      decided: storedConsent?.decided === true
    }
  } catch (error) {
    return {...defaultConsent}
  }
}

export const saveConsent = preferences => {
  const consent = {
    necessary: true,
    preferences: preferences === true,
    decided: true,
    updatedAt: new Date().toISOString()
  }

  localStorage.setItem(CONSENT_KEY, JSON.stringify(consent))

  if (!consent.preferences) {
    localStorage.removeItem('Configuration')
    localStorage.removeItem('Calculation')
  }

  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, {detail: consent}))
  return consent
}

export const hasPreferenceConsent = () => getConsent().preferences

export const getPreferenceItem = key => (
  hasPreferenceConsent() ? localStorage.getItem(key) : null
)

export const setPreferenceItem = (key, value) => {
  if (hasPreferenceConsent()) {
    localStorage.setItem(key, value)
  }
}

export const removePreferenceItem = key => localStorage.removeItem(key)

export const openConsentSettings = () => {
  window.dispatchEvent(new CustomEvent('myservices-open-consent-settings'))
}

export {CONSENT_EVENT}
